<template>
    <div class="s-event-questions">
        <h2 v-if="l10n.title" class="title">
            {{ l10n.title }}
        </h2>
        <a-accordion class="faq-accordion" one-only-mode>
            <a-accordion-item
                v-for="item in l10n.questions"
                :key="item.question"
                class="faq-accordion-item"
                title-tag="h3"
                :title="item.question"
            >
                <template v-for="block in item.answer.blocks">
                    <div v-if="block.type === 'header'" :key="block.id" class="description-wrap">
                        <component :is="getTitleElement(block)" class="description">
                            <a-dangerous-html :content="block.data.text" tag="span" />
                        </component>
                    </div>
                    <p v-else-if="block.type === 'paragraph'" :key="block.id" class="description-paragraph">
                        <a-dangerous-html :content="block.data.text" tag="span" />
                    </p>
                    <component
                        :is="getListElement(block)"
                        v-else-if="block.type === 'list'"
                        :key="block.id"
                        class="description-list"
                    >
                        <li v-for="(listItem, j) in block.data.items" :key="j" class="description-list-item">
                            <a-dangerous-html :content="listItem.content ?? listItem" tag="span" />
                        </li>
                    </component>
                </template>
            </a-accordion-item>
        </a-accordion>
    </div>
</template>
<script>
import AAccordionItem from '@core/components/accordion/accordion-item.vue';
import AAccordion from '@core/components/accordion/accordion.vue';
import ADangerousHtml from '@core/components/dangerous-html/dangerous-html.vue';
import l10n from '@core/mixins/l10n.js';

export default {
    name: 'SEventQuestions',

    components: {
        ADangerousHtml,
        AAccordion,
        AAccordionItem,
    },

    mixins: [l10n],

    props: {
        /**
         * Title
         */
        title: {
            type: String,
            required: true,
        },

        /**
         * Questions
         */
        questions: {
            type: Array,
            required: true,
        },
    },

    methods: {
        getTitleElement(block) {
            const level = Math.max(block.data?.level || 2, 2);
            return `h${level}`;
        },

        getListElement(block) {
            return block?.data?.style === 'ordered' ? 'ol' : 'ul';
        },
    },
};
</script>

<style lang="postcss" scoped>
.s-event-questions {
    color: var(--av-nav-primary);

    .title {
        @mixin display-accent;
        margin-bottom: 48px;

        @media (--viewport-desktop) {
            @mixin hero-accent;
        }
    }
}

.a-accordion {
    @media (--viewport-desktop-wide) {
        @mixin colls 9;
    }
}

.a-accordion .a-accordion-item.faq-accordion-item {
    border-radius: 8px;
    padding: 24px 16px;
    margin: 0 0 16px;
    background: var(--av-solid-brand-lightest);
    border: 0;

    &:last-of-type {
        border: 0;
    }

    :deep(.title) {
        @mixin lead-accent;
        align-items: flex-start;
        padding: 0;
    }

    :deep(.content-wrapper) {
        padding: 16px 0 0 24px;
        margin-bottom: -16px;
    }

    .description {
        @mixin paragraph-accent;
        color: var(--av-fixed-primary);
        margin-bottom: 16px;
    }

    .description-paragraph {
        @mixin paragraph;
        margin-bottom: 16px;
    }

    .description-list {
        margin-bottom: 16px;

        &:is(ol) {
            list-style-type: decimal;
            padding-inline-start: 16px;

            @media (--viewport-mobile-wide) {
                padding-inline-start: 32px;
            }

            .post-body__list-item {
                padding-inline-start: 3px;
            }
        }

        &:is(ul) {
            .description-list-item {
                margin-bottom: 16px;

                &::before {
                    content: '';
                    display: inline-block;
                    height: 3px;
                    width: 3px;
                    background: var(--av-fixed-secondary);
                    margin: 0 10px 0 6px;
                    position: relative;
                    top: -3px;
                }
            }
        }
    }
}
</style>
